import Store from 'store/store';

function addToLanguageLabel(label, langCode, copyFullLanguages, textFromCopy) {
	const text = (textFromCopy || '').replace('<lang>', copyFullLanguages[langCode]);
	label += (label.length ? ` (${text})` : text);
	return label;
}

export function generateLanguageLabel(screening) {
	let label = '';
	const appData = Store.get()?.appData || {};
	const copy = appData.copy?.baseCopy || {};
	const copyFullLanguages = copy.languages || {};
	const appLanguage = appData.meta?.region?.language;
	const alwaysShowOriginalLanguage = appData.pages?.boltShowtimes?.data?.alwaysShowOriginalLanguage || false;
	const shouldShowOriginalLanguage = alwaysShowOriginalLanguage || (screening.language !== appLanguage);
	if (screening.language && shouldShowOriginalLanguage) {
		const originalLanguage = (copy.$ORIGINAL_LANGUAGE || '').replace('<lang>', copyFullLanguages[screening.language]);
		label += originalLanguage;
	}
	// if (screening.dubbing) {
	// 	label = addToLanguageLabel(label, screening.dubbing, copyFullLanguages, copy.$LANGUAGE_DUB);
	// }
	if (screening.subtitles) {
		label = addToLanguageLabel(label, screening.subtitles, copyFullLanguages, copy.$LANGUAGE_SUB);
	}
	return label;
}

export function getFormatImage(name, category, theater, sharedImageRoot, logoShade) {
	const shade = logoShade === 'light' ? 'dark' : 'light';

	const formatLower = (category?.format || name || '')?.toLowerCase();
	const isFormat = c => formatLower.includes(c);
	const logoImg = name => `${sharedImageRoot}/logos/formats/${shade}/${name}.png`;

	// In this order, check for d-box 3d before d-box
	if (isFormat('d-box 3d')) {
		return logoImg('dbox3d');
	}

	if (isFormat('d-box')) {
		return logoImg('dbox');
	}

	let isDolby = category?.audioDetails?.some(data => data.toLowerCase().includes('dolby'));
	let isAMC = theater?.chain?.slug === 'amc-theatres';
	if (isDolby && isAMC) {
		return logoImg('dolby_amc');
	}

	if (isFormat('prime') && isFormat('amc')) {
		return logoImg('prime_amc');
	}

	if (isFormat('reald') && isFormat('3d')) {
		return logoImg('reald3d');
	}

	if (isFormat('reald')) {
		return logoImg('reald');
	}

	if (isFormat('imax') && isFormat('70mm')) {
		return logoImg('imax70mm');
	}

	if (isFormat('imax') && isFormat('3d')) {
		return logoImg('imax3d');
	}

	if (isFormat('imax')) {
		return logoImg('imax');
	}

	if (isFormat('4dx')) {
		return logoImg('4dx');
	}

	if (isFormat('atmos')) {
		return logoImg('atmos');
	}

	if (isFormat('avx')) {
		return logoImg('avx');
	}

	if (isFormat('screenx')) {
		return logoImg('screenx');
	}

	if (isFormat('4dxscreen')) {
		return logoImg('4dxscreen');
	}

	if (isFormat('4dx-screen')) {
		return logoImg('4dxscreen');
	}

	if (isFormat('vip')) {
		return logoImg('vip');
	}
}
